"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPlayableDigitalRevealGames = exports.skipGame = exports.endGame = exports.startGame = exports.getPlayForPointsActivity = exports.updateGame = exports.getGameConfig = exports.SKIP_GAME = exports.END_GAME = exports.START_GAME = exports.FETCH_DIGITAL_REVEAL_PLAYABLE = exports.GET_PLAY_FOR_POINTS_ACTIVITY = exports.UPDATE_GAME_CONFIG = exports.GET_GAME_CONFIG = void 0;
var loyalty_1 = require("@pbl/pbl-react-core/lib/models/loyalty");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var JsonUtils_1 = require("@pbl/pbl-react-web-components/lib/utils/JsonUtils");
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../../redux/action-type.util");
var actions_1 = require("../app/actions");
exports.GET_GAME_CONFIG = 'interactive-games/GET_GAME_CONFIG';
exports.UPDATE_GAME_CONFIG = 'interactive-games/UPDATE_GAME_CONFIG';
exports.GET_PLAY_FOR_POINTS_ACTIVITY = 'interactive-games/GET_PLAY_FOR_POINTS_ACTIVITY';
exports.FETCH_DIGITAL_REVEAL_PLAYABLE = 'interactive-games/FETCH_DIGITAL_REVEAL_PLAYABLE';
exports.START_GAME = 'interactive-games/START_GAME';
exports.END_GAME = 'interactive-games/END_GAME';
exports.SKIP_GAME = 'interactive-games/END_GAME';
var getGameConfig = function (extraData, gameType) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var gameConfig, playForPointsActivity, _a, _b, payload, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 11]);
                dispatch({ type: (0, action_type_util_1.REQUEST)(exports.GET_GAME_CONFIG) });
                gameConfig = void 0;
                playForPointsActivity = null;
                if (!extraData) return [3, 5];
                if (!(extraData.is_play_for_fun_only && extraData.is_play_for_fun_only === 'true')) return [3, 2];
                return [4, services_1.GamesService.getGameConfig(extraData.game_number)];
            case 1:
                gameConfig = _c.sent();
                return [3, 5];
            case 2:
                if (!(extraData.is_play_for_fun && extraData.is_play_for_fun === 'true')) return [3, 5];
                _b = (_a = loyalty_1.Activity).JsonToActivity;
                return [4, services_1.LoyaltyService.getActivity(extraData.points_activity_id)];
            case 3:
                playForPointsActivity = _b.apply(_a, [_c.sent()]);
                if (!(gameType === 'prize' &&
                    playForPointsActivity &&
                    playForPointsActivity.freq_cap !== null &&
                    playForPointsActivity.user_num_completions !== null &&
                    playForPointsActivity.freq_cap > playForPointsActivity.user_num_completions)) return [3, 5];
                return [4, services_1.GamesService.getGameConfig(extraData.points_game_number)];
            case 4:
                gameConfig = _c.sent();
                _c.label = 5;
            case 5:
                if (!!gameConfig) return [3, 7];
                return [4, services_1.GamesService.getGameConfig(extraData.game_number)];
            case 6:
                gameConfig = _c.sent();
                _c.label = 7;
            case 7:
                if (!extraData.digital_reveal) return [3, 9];
                return [4, services_1.InteractiveGameService.generatePlayForFunToken(extraData.digital_reveal, gameConfig.prizes)];
            case 8:
                payload = _c.sent();
                if (!!payload) {
                    gameConfig = __assign(__assign(__assign({}, gameConfig), payload), { face: (0, JsonUtils_1.parseJson)(payload.face), gameConfig: (0, JsonUtils_1.parseJson)(payload.gameConfig), prizes: gameConfig.prizes });
                }
                _c.label = 9;
            case 9:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(exports.GET_GAME_CONFIG),
                    payload: { game: gameConfig, playForPointsActivity: playForPointsActivity }
                });
                return [3, 11];
            case 10:
                error_1 = _c.sent();
                dispatch({ type: (0, action_type_util_1.FAILURE)(exports.GET_GAME_CONFIG) });
                dispatch((0, actions_1.showMessageBar)({ message: error_1.payload.errorKey, type: 'error' }));
                return [3, 11];
            case 11: return [2];
        }
    });
}); }; };
exports.getGameConfig = getGameConfig;
var updateGame = function (gameConfigId) { return function (dispatch) {
    dispatch({
        type: exports.UPDATE_GAME_CONFIG,
        payload: services_1.GamesService.updateGame(gameConfigId)
    }).catch(function (error) {
        dispatch((0, actions_1.showMessageBar)({ message: error.payload.errorKey, type: 'error' }));
    });
}; };
exports.updateGame = updateGame;
var getPlayForPointsActivity = function (extraData) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var playForPointsActivity, _a, _b, error_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                dispatch({ type: (0, action_type_util_1.REQUEST)(exports.GET_PLAY_FOR_POINTS_ACTIVITY) });
                playForPointsActivity = null;
                if (!(extraData && extraData.is_play_for_fun && extraData.is_play_for_fun === 'true')) return [3, 2];
                _b = (_a = loyalty_1.Activity).JsonToActivity;
                return [4, services_1.LoyaltyService.getActivity(extraData.points_activity_id)];
            case 1:
                playForPointsActivity = _b.apply(_a, [_c.sent()]);
                _c.label = 2;
            case 2:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(exports.GET_PLAY_FOR_POINTS_ACTIVITY),
                    payload: { playForPointsActivity: playForPointsActivity }
                });
                return [3, 4];
            case 3:
                error_2 = _c.sent();
                dispatch({ type: (0, action_type_util_1.FAILURE)(exports.GET_PLAY_FOR_POINTS_ACTIVITY) });
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.getPlayForPointsActivity = getPlayForPointsActivity;
var startGame = function (digitalRevealToken) { return function (dispatch) {
    dispatch({
        type: exports.START_GAME,
        payload: services_1.InteractiveGameService.startGame(digitalRevealToken)
    }).catch(function (error) {
        dispatch((0, actions_1.showMessageBar)({ message: error.payload.errorKey, type: 'error' }));
    });
}; };
exports.startGame = startGame;
var endGame = function (digitalRevealToken) { return function (dispatch) {
    dispatch({
        type: exports.END_GAME,
        payload: services_1.InteractiveGameService.endGame(digitalRevealToken)
    }).catch(function (error) {
        dispatch((0, actions_1.showMessageBar)({ message: error.payload.errorKey, type: 'error' }));
    });
}; };
exports.endGame = endGame;
var skipGame = function (digitalRevealToken) { return function (dispatch) {
    dispatch({
        type: exports.SKIP_GAME,
        payload: services_1.InteractiveGameService.skipGame(digitalRevealToken)
    }).catch(function (error) {
        dispatch((0, actions_1.showMessageBar)({ message: error.payload.errorKey, type: 'error' }));
    });
}; };
exports.skipGame = skipGame;
var fetchPlayableDigitalRevealGames = function (page) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: exports.FETCH_DIGITAL_REVEAL_PLAYABLE,
                payload: services_1.InteractiveGameService.getPlayableTokens(constants_1.default.HISTORY_ITEMS_PER_PAGE, page)
            });
        }
        catch (e) {
            dispatch((0, actions_1.showMessageBar)({ message: e === null || e === void 0 ? void 0 : e.payload.errorKey, type: 'error' }));
        }
        return [2];
    });
}); }; };
exports.fetchPlayableDigitalRevealGames = fetchPlayableDigitalRevealGames;
//# sourceMappingURL=actions.js.map